import { useState } from 'react'
import { cn } from '@lib/utils/helpers'
import { openOrganizationLogoDownload } from '../../utils/downloadOrganizationLogo'
import type { OrganizationLogoDownloadAction } from '../../types'

export function OrganizationLogoPreview({
  src,
  download,
}: {
  src: string | null
  download?: OrganizationLogoDownloadAction
}) {
  const [serverDownloading, setServerDownloading] = useState(false)

  if (!src) return null
  const previewBox = 'min-h-[96px] sm:min-h-[104px]'
  const imgClass = 'max-h-[136px] max-w-full min-w-0 object-contain'

  return (
    <div className="mt-2 w-full min-w-0">
      <div
        className={cn(
          'flex w-full min-w-0 items-center justify-center rounded border border-slate-200 bg-slate-50/60 p-3 shadow-sm',
          previewBox,
        )}
      >
        <img src={src} alt="" className={cn('mx-auto block', imgClass)} />
      </div>
      {download?.kind === 'local' && (
        <a
          href={download.objectUrl}
          download={download.file.name}
          className="mt-2 inline-block bg-transparent text-sm text-blue-600 underline hover:text-blue-800"
        >
          Download File
        </a>
      )}
      {download?.kind === 'server' && (
        <button
          type="button"
          disabled={serverDownloading}
          className="mt-2 inline-block cursor-pointer bg-transparent p-0 text-sm text-blue-600 underline hover:text-blue-800 disabled:opacity-60"
          onClick={async () => {
            setServerDownloading(true)
            try {
              await openOrganizationLogoDownload(download.orgId, download.filePath)
            } finally {
              setServerDownloading(false)
            }
          }}
        >
          {serverDownloading ? 'Opening…' : 'Download File'}
        </button>
      )}
    </div>
  )
}
